import React__default, { useReducer, useRef, useMemo } from 'react';
import PropTypes from 'prop-types';
import { showWarning } from '../../hooks/useWarning.js';
import { DialogsContext } from './DialogsContext.js';

const initialState = [];
const reducer = (state, {
  type,
  payload
}) => {
  switch (type) {
    case 'open':
      return [...state, {
        ...payload,
        isOpen: true
      }];
    case 'update':
      if (!state.find(dialog => dialog.id === payload.id)) return state;
      return state.map(dialog => dialog.id !== payload.id ? dialog : {
        ...dialog,
        ...payload,
        props: {
          ...dialog.props,
          ...payload.props
        }
      });
    case 'close':
      if (!state.find(dialog => dialog.id === payload)) return state;
      return state.map(dialog => dialog.id !== payload ? dialog : {
        ...dialog,
        isOpen: false
      });
    case 'remove':
    case 'cleanup':
      if (!state.find(dialog => dialog.id === payload)) return state;
      process.env.NODE_ENV !== "production" ? showWarning(type === 'cleanup', 'Cleaning up dialog, perhaps you forgot to pass `onClosed` callback.') : void 0;
      return state.filter(dialog => dialog.id !== payload);
    case 'clearAll':
      return initialState;
    default:
      return state;
  }
};
const DialogsProvider = ({
  children
}) => {
  const [dialogs, dispatch] = useReducer(reducer, initialState);
  const blocker = useRef();
  const nextId = useRef(0);
  const value = useMemo(() => ({
    dialogs,
    dispatch,
    blocker,
    nextId
  }), [dialogs]);
  return /*#__PURE__*/React__default.createElement(DialogsContext.Provider, {
    value: value
  }, children);
};
DialogsProvider.propTypes = {
  children: PropTypes.node
};
DialogsProvider.displayName = 'NuiDialogsProvider';
var DialogsProvider$1 = DialogsProvider;

export { DialogsProvider$1 as default };
